<template>
    <div class="OrderList">
    <GlobalInfoBar title="回收订单" type="orderMa"  content="管理回收商家或门店的报价订单，订单数据仅支持查看，不可操作" >
    </GlobalInfoBar>
    <GlobalChunk icon="search" title="筛选查询">
      <div slot="filter">
        <div class="serchtype"> 
          <div :class="{'typecolor':selectId==item.id}" @click="selectType(item.id)" v-for="item in typeData" :key="item.id">{{ item.name }}</div>
        </div>
        <OrderFrom :classList="classList" v-if="classList&&selectId==1" ref="childForm"/>
        <finaceFrom :classList="classList" v-if="classList&&selectId==2" ref="childForm"/>
      </div>
      <div class="caseOrder">
          <OrderTable v-if="selectId==1" @getUnPayUserOrders="getUnPayUserOrders"/>
          <finaceTable v-else @getUnPayUserOrders="getUnPayUserOrders"/>
      </div>
    </GlobalChunk>
  </div>
</template>

<script>
import _api from "@/utils/request";
import OrderFrom from "./From"
import OrderTable from "./table"
import finaceFrom from "./finanaceFrom.vue"
import finaceTable from "./financeTable.vue"
export default {
  name: "OrderList",
  components:{OrderFrom,OrderTable,finaceTable,finaceFrom},
  data() {
    return {
      selectId:'1',
      classList: null,
      merchantId: '',
      UnPayUserOrders: 0,
      typeData:[{
        name:'常规查询',
        type:'00',
        id:1
      },{
        name:'归档查询',
        type:'01',
        id:2
      }]
    };
  },
  created() {
    this.getClassList()
  },
  methods: {
    selectType(data){
      if(data==this.selectId)return
        this.selectId=data
    },
    // 获取分类集合
    getClassList() {
      _api.selectList().then(res => {
        console.log(res)
        this.classList = res.data?res.data:[]
      })
    },
    getUnPayUserOrders(e) {
      this.UnPayUserOrders = e
    },
    searchUnPayUserOrders(){
      this.$refs.childForm.searUnPayUserOrders()
    }
  }
};
</script>

<style scoped lang="scss" ref="stylesheet/scss">
.OrderList {
  .case {
    display: flex;
    align-items: center;
    justify-content: space-between;
    .case-title {
      display: flex;
      .case-title_icon {
        width: 20px;
        height: 20px;
      }
      .case-title_max {
        font-weight: bold;
        color: #333333;
        font-size: 18px;
        width: 80px;
        height: 17px;
        line-height: 17px;
        font-family: FZLanTingHei-B-GBK;
      }
    }
  }
  .caseOrder {
        margin: 0 5px;
        background: #f5f6fa;
        border-radius: 10px;
    }
}
.serchtype{
  margin: -10px 0 20px 15px;
  display: flex;
  align-items: center;
}
.serchtype>div{
  cursor: pointer;
  margin-right: 20px;
  font-size: 17px;
}
.typecolor{
  color: #0981ff;
}
</style>
